import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AuthGuard } from './guards/auth.guard';
import { DietComponent } from './pages/diet/diet.component';
import { RoutinesComponent } from './pages/routines/routines.component';
import { RegisterSuccessComponent } from './pages/register-success/register-success.component';
import { TabletHomeComponent } from './pages/tablet-home/tablet-home.component';
import { TutorialsTabletComponent } from './pages/tutorials-tablet/tutorials-tablet.component';
import { AutomaticRoutinesListTabletComponent } from './pages/automatic-routines-list-tablet/automatic-routines-list-tablet.component';
import { TabletAutoassinedRoutinesComponent } from './pages/tablet-autoassined-routines/tablet-autoassined-routines.component';
import { TabletRoutineComponent } from './pages/tablet-routine/tablet-routine.component';
import { UserFormsComponent } from './pages/user-forms/user-forms.component';
import { MobileOwnDietComponent } from './pages/mobile-own-diet/mobile-own-diet.component';
import { ContactComponent } from './pages/contact/contact.component';
import { TermsAndConditionsPage } from './pages/terms-and-conditions/terms-and-conditions.page';
import { PrivacyPolicyPage } from './pages/privacy-policy/privacy-policy.page';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'login-tablet',
    component: LoginComponent,
  },
  {
    path: 'tutorials-tablet',
    component: TutorialsTabletComponent,
  },
  {
    path: 'home-tablet',
    component: TabletHomeComponent,
  },
  {
    path: 'routines-tablet',
    component: TabletAutoassinedRoutinesComponent,
  },
  {
    path: 'routine-model-tablet/:routineId',
    component: TabletRoutineComponent,
  },
  {
    path: 'automatic-routines',
    component: AutomaticRoutinesListTabletComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'mobile-own-diet',
    component: MobileOwnDietComponent,
  },
  {
    path: 'diet-history/:userId',
    component: DietComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'routines/:userId',
    component: RoutinesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'register-success',
    component: RegisterSuccessComponent,
  },
  {
    path: 'user-forms/:userId',
    component: UserFormsComponent,
  },
  {
    path: 'contact',
    component: ContactComponent,
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsPage,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyPage,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
